module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"add-media":"Importar mídias","empty-album-title":"Álbum vazio","empty-album-description":"Não há fotos ou vídeos ainda. Adicione mídias arrastando-as aqui ou clicando no menu acima.","empty-album-md-description":"Não há fotos ou vídeos ainda. Adicione novas mídias clicando no menu acima."}}')
  delete Component.options._Ctor
}
